import { IPaginationDTO, IPaginationResponse } from '@/models/pagination.model';

export enum InterLinkEndpoints {
  ROOT = '/inter-link-sections',
}

export const staticInterLinkEndpoints = {
  GET_INTER_LINK_LIST: `${InterLinkEndpoints.ROOT}/list`,
  CREATE_INTER_LINK: InterLinkEndpoints.ROOT,
  IMPORT_LINKS: `${InterLinkEndpoints.ROOT}/import`,
  EXPORT_IMPORT_LINKS: `${InterLinkEndpoints.ROOT}/export`,
};

export const getInterLinkEndpoints = ({ id }: { id: string }) => ({
  UPDATE_INTER_LINK: `${InterLinkEndpoints.ROOT}/${id}`,
  DELETE_INTER_LINK: `${InterLinkEndpoints.ROOT}/${id}`,
});

export interface IPagePath {
  title: string;
  path: string;
}

export interface IInterLink {
  id: string;
  channelId?: number;
  depth?: number;
  createdAt?: string;
  updatedAt?: string;
  pagePath?: string;
  links?: IPagePath[];
}

// ============== DTO ==============

export type IGetInterLinksDTO = IPaginationDTO & {
  search?: string;
  channelId?: number;
};

export type ICreateInterLinkDTO = Omit<IInterLink, 'id'>;

export type IDeleteInterLinkDTO = {
  id: string;
};

export type IUpdateInterLinkDTO = Partial<IInterLink> & {
  id: string;
};

export type IInterLinkImportDTO = {
  channelId: number;
  file: File;
};

export type IExportInterLinks = {
  channelId?: number;
};

// ============== Response ==============

export type ICreateInterLinkResponse = IInterLink;

export type IUpdateInterLinkResponse = IInterLink;

export type IDeleteInterLinkResponse = IInterLink;

export type IGetInterLinksResponse = { sections: IInterLink[] } & IPaginationResponse;

export type IInterLinksImportResponse = {
  success: boolean;
  error?: string;
};
